export function easeOutCubic(t: number): number {
  return 1 - (1 - t) ** 3;
}

export function easeInOutCubic(t: number): number {
  return t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2;
}

export function prefersReducedMotion(): boolean {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export const UNPACK_ZONE = 480;
export const CONVERGE_ZONE = 520;

export function getScrollPhases() {
  const scrollY = window.scrollY;
  const scrollBottom = scrollY + window.innerHeight;
  const remaining = document.documentElement.scrollHeight - scrollBottom;

  const unpack = easeInOutCubic(Math.min(1, scrollY / UNPACK_ZONE));
  const bottomConverge = easeOutCubic(
    1 - Math.min(1, Math.max(0, remaining / CONVERGE_ZONE))
  );

  return { unpack, bottomConverge };
}

export function isMobileViewport(): boolean {
  return window.innerWidth < 640;
}
